import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import Button from '../../atoms/Button';
import Link from '../../atoms/icons/Link';
import Image from '../../atoms/icons/Image';
import { color } from '../../templates/Ui';
import { Disclosure } from '@headlessui/react';
export const StyledTableCell = styled(TableCell) `
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    gap: 10px;

    svg {
        fill: #a8a8a8;
    }
`;
export const ImagePreview = styled.img `
    width: 70px;
    height: 44px;
    object-fit: cover;
`;
export const Tooltip = styled.div `
    position: absolute;
    box-shadow: 0 0 5px rgb(26 26 26 / 10%);
    background-color: #ffffff;
    border-radius: 6px;
    visibility: hidden;
    width: 350px;
    text-align: left;
    padding: 10px;
    z-index: 1;
    top: -20px;
    opacity: 0;
    transition: opacity 0.3s;
    word-break: break-word;
`;
export const ModalButton = styled(Button) `
    display: inline-block;
    margin-right: auto;
    padding: 0;
    background-color: transparent;
`;
export const StyledLink = styled.a `
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: ${props => props.theme.primary.base};

    &:hover {
        text-decoration: none;

        ~ ${Tooltip} {
            visibility: visible;
            opacity: 1;
        }
    }
`;
export const StyledLinkIcon = styled(Link) `
    fill: #a8a8a8;
`;
export const StyledImage = styled(Image) `
    fill: #a8a8a8;
`;
export const StyledTableGroup = styled.div `
    margin-bottom: 10px;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(26, 26, 26, 0.11);
`;
export const StyledTableRow = styled(TableRow) `
    &:nth-child(even) {
        background-color: ${color.body.base};
    }
`;
export const StyledTableNestedRow = styled(StyledTableRow) ``;
export const StyledTableCellDetectionInline = styled.div `
    display: flex;
    gap: 8px;
    align-items: center;
`;
export const StyledTableCollapseButton = styled(Disclosure.Button) `
    background: none;
    border: none;
    cursor: pointer;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
        margin-right: 0px !important;
    }
`;
